import { render, staticRenderFns } from "./CreateZone.vue?vue&type=template&id=58a84658"
import script from "./CreateZone.vue?vue&type=script&lang=js"
export * from "./CreateZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports